import { ICellRenderer } from 'ag-grid-community';
import { Type } from '@angular/core';
import { Period } from '@portal-shared/app/entities/period.model';
import { AdequacyPeriodCellRendererComponent } from '@shared/components/grids/row-cell-renderers/adequacy-period-cell-renderer/adequacy-period-cell-renderer.component';
import { ClassGroupCellRendererComponent } from '@shared/components/grids/row-cell-renderers/class-group-cell-renderer/class-group-cell-renderer.component';
import { DepartmentGroupCellRendererComponent } from '@shared/components/grids/row-cell-renderers/department-group-cell-renderer/department-group-cell-renderer.component';
import { PeriodCapacityCellRendererComponent } from '@shared/components/grids/row-cell-renderers/period-capacity-cell-renderer/period-capacity-cell-renderer.component';
import { PeriodPlanningProgressCellRendererComponent } from '@shared/components/grids/row-cell-renderers/period-planning-progress-cell-renderer/period-planning-progress-cell-renderer.component';
import { ProjectGroupCellRendererComponent } from '@shared/components/grids/row-cell-renderers/project-group-cell-renderer/project-group-cell-renderer.component';
import { ResourceCellRendererComponent } from '@shared/components/grids/row-cell-renderers/resource-cell-renderer/resource-cell-renderer.component';
import { TotalHoursPeriodCellRendererComponent } from '@shared/components/grids/row-cell-renderers/total-hours-period-cell-renderer/total-hours-period-cell-renderer.component';
import { PlanningBoardGroupRowType } from '@shared/components/grids/rows/groups/planning-board-group-row-type.enum';
import { isNil } from 'lodash-es';

export class GroupCellRendererFactory {
  private static cellRenderers = new Map<PlanningBoardGroupRowType, Type<ICellRenderer>>([
    [PlanningBoardGroupRowType.Resource, ResourceCellRendererComponent],
    [PlanningBoardGroupRowType.Project, ProjectGroupCellRendererComponent],
    [PlanningBoardGroupRowType.Department, DepartmentGroupCellRendererComponent],
    [PlanningBoardGroupRowType.Class, ClassGroupCellRendererComponent]
  ]);

  private static periodCellRenderers = new Map<PlanningBoardGroupRowType, (p: Period) => Type<ICellRenderer>>([
    [
      PlanningBoardGroupRowType.Resource,
      p => (p.hasActualHours ? AdequacyPeriodCellRendererComponent : PeriodCapacityCellRendererComponent)
    ],
    [
      PlanningBoardGroupRowType.Project,
      p => (p.hasActualHours ? AdequacyPeriodCellRendererComponent : PeriodPlanningProgressCellRendererComponent)
    ],
    [
      PlanningBoardGroupRowType.Department,
      p => (p.hasActualHours ? AdequacyPeriodCellRendererComponent : PeriodPlanningProgressCellRendererComponent)
    ],
    [PlanningBoardGroupRowType.Class, () => TotalHoursPeriodCellRendererComponent]
  ]);

  public static getPeriodCellRenderer(rowType: PlanningBoardGroupRowType, period: Period): Type<ICellRenderer> {
    const periodFunction = this.periodCellRenderers.get(rowType);

    if (isNil(periodFunction)) {
      throw new Error(`Undefined Period Cell renderer for row type ${rowType}`);
    }

    return periodFunction(period);
  }

  public static getGroupCellRenderer(rowType: PlanningBoardGroupRowType) {
    const cellRenderer = this.cellRenderers.get(rowType);

    if (isNil(cellRenderer)) {
      throw new Error(`Undefined Period Cell renderer for row type ${rowType}`);
    }

    return cellRenderer;
  }
}
